import { Injectable } from '@angular/core';
import { StorageService } from '@core/services/storage.service';
import { getBrowserCultureLang, TranslocoService } from '@ngneat/transloco';
import { TranslocoLocaleService } from '@ngneat/transloco-locale';
import { en_US, NzI18nService, tr_TR } from 'ng-zorro-antd/i18n';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class I18nService {

  private languageKey = 'language';
  unSubscribeLang = new Subject();

  constructor(
    private storageService: StorageService,
    private translocoService: TranslocoService,
    private nz18NService: NzI18nService,
    private translocoLocaleService: TranslocoLocaleService) { }

  /**
   * language init
   */
  init(): void {
    this.language = '';

    // dil değişimi olduğunda yapılacak işlemler.
    this.translocoService.langChanges$.pipe(takeUntil(this.unSubscribeLang)).subscribe(lang => {
      this.storageService.set(this.languageKey, lang);
      this.nz18NService.setLocale(lang === 'tr-TR' ? tr_TR : en_US);
      this.translocoLocaleService.setLocale(lang);
    });
  }

  /**
   * set language
   * @param {string} language
   */
  set language(lang: string) {

    lang = lang || localStorage.getItem(this.languageKey) || getBrowserCultureLang();
    const checkLanguage = this.translocoService.getAvailableLangs().some((o: any) => o.id === lang);

    if (!checkLanguage) {
      lang = this.translocoService.getDefaultLang();
    }
    this.translocoService.setActiveLang(lang);
  }

  /**
   * get language
   */
  get language(): string {
    return this.translocoService.getActiveLang();
  }

  destroy(): void {
    if (this.unSubscribeLang) {
      this.unSubscribeLang.next();
      this.unSubscribeLang.complete();
    }
  }
}
